module.exports = __webpack_public_path__ + "img/mitarbeiter-accounts.373059af.png";